/*
 * Author: Harper Yan
 * File Created: Monday, 24-08-05 06:56 pm
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */

import type { BoxProps } from '@mui/material';
import type { ButtonProps } from '@mui/material/Button';
import Button from '@mui/material/Button';
import { Flex } from '@ucard/ds/containers';
export interface ButtonGroupProps extends BoxProps {
  btn1: ButtonProps;
  btn2?: ButtonProps;
  direction?: 'horizontal' | 'vertical';
}
export default function ButtonGroup(props: ButtonGroupProps) {
  const {
    btn1,
    btn2,
    direction = 'horizontal',
    ...others
  } = props;
  return <Flex flexDirection={direction === 'horizontal' ? 'row' : 'column'} gap="15px" width="100%" {...others} data-sentry-element="Flex" data-sentry-component="ButtonGroup" data-sentry-source-file="index.tsx">
      <Button color={btn2 ? 'secondary' : 'primary'} size="medium" sx={{
      flex: 1
    }} {...btn1} data-sentry-element="Button" data-sentry-source-file="index.tsx" />
      {btn2 && <Button color="primary" size="medium" sx={{
      flex: 1
    }} {...btn2} />}
    </Flex>;
}